import { Banknote } from "lucide-react";

// Thin notice under the navbar: FonderX is a cash business.
export default function CashOnlyBanner() {
  return (
    <div className="bg-[#001435] border-b border-white/10" data-testid="cash-only-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center gap-3 py-2.5 text-center">
          <span className="hidden sm:inline-flex w-7 h-7 rounded-full bg-[#00d9c0]/15 border border-[#00d9c0]/30 items-center justify-center flex-shrink-0">
            <Banknote className="w-4 h-4 text-[#00d9c0]" />
          </span>
          <p className="text-sm text-blue-100/80">
            <span className="font-semibold text-white">Cash only.</span>{" "}
            We are a cash exchange. Every transaction is paid and settled in cash at our counter.
            <span className="hidden md:inline text-blue-100/50"> No cards, e-transfer or cheques.</span>
          </p>
        </div>
      </div>
    </div>
  );
}
